import Ventana from "../../../isp.pantalla.principal/reductores/ventanas/Ventana";
import { ModosOp } from "../../../isp.pantalla.principal/reductores/Constantes";
import getEstadoInicial from "../EstadoDialogoItem";

export default class VentanaItem extends Ventana {
    constructor() {
        super();
        this.estadoComp = getEstadoInicial();
        /* this.estadoCom = {
            domain: {
                screen: {
                    idCliente: null,
                },
            },
            flag: {
                modoOperacion: ModosOp.CREAR,
                modal: false,
                cargandoEntidad: false,
            },
        }; */
        this.dispatch = null;
        // this.ventanaCargando=null
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaItem)) {
            return false;
        }

        if (
            this.estadoComp.flag.modoOperacion === ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion === ModosOp.CREAR
        ) {
            return true;
        }

        if (
            this.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            this.estadoComp.domain.screen.idCliente ===
                ventanaAAbrir.estadoComp.domain.screen.idCliente
        ) {
            return true;
        }

        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaItem();
        nuevaVentana.id = this.id;
        nuevaVentana.posicionZ = this.posicionZ;
        nuevaVentana.estadoComp = this.estadoComp;
        nuevaVentana.dispatch = this.dispatch;
        // nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }
}
